import { useEffect } from 'react';
export var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
export var useOnClickOutsideWithNode = function useOnClickOutsideWithNode(node, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      var _event$target;

      if (!node || node.contains(event.target) || !((_event$target = event.target) !== null && _event$target !== void 0 && _event$target.isConnected)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [node, handler]);
};